<ngx-spinner type="ball-clip-rotate"></ngx-spinner>
<ng-container *ngIf="initialized">
  <div *ngIf="page === 'login'">
    <app-traders-login></app-traders-login>
  </div>

  <div *ngIf="page === 'register'">
    <app-traders-register></app-traders-register>
  </div>

  <div *ngIf="page === 'forgot-password'">
    <app-traders-forgot-password></app-traders-forgot-password>
  </div>

  <!-- 送信しましたページ -->
  <div *ngIf="page === 'password-reset-send'">
    <app-traders-change-password-sent></app-traders-change-password-sent>
  </div>

  <app-traders-register-resend
    *ngIf="page === 'register-resend'"
  ></app-traders-register-resend>
</ng-container>
